import ApiBase from '../../../features/shared/services/ApiBase';

export default class CurrentUserApi extends ApiBase {
  identity() {
    return this.http.get('identity');
  }
}



// WEBPACK FOOTER //
// ./app/features/authentication/services/CurrentUserApi.js